import { gql } from "apollo-boost";

export const CONFIRM_SAVED_OPEN_HOUSE_ATTENDANCE = gql`
  mutation confirm_saved_open_house_attendance(
    $saved_open_house_id: ID!
    $attended: Boolean!
  ) {
    confirm_saved_open_house_attendance(
      input: { saved_open_house_id: $saved_open_house_id, attended: $attended }
    ) {
      successful
      errors
    }
  }
`;
